export default {
  form: {
    kfName: "客服名称",
    time: "日期范围",
    status: "客服状态",
  },
  table: {
    kfName: "客服名称",
    status: "客服状态",
    oprType: "操作类型",
    duration: "状态持续时间",
    createdAt: "创建时间",
    connect: "连接",
    manualSwitch: "手动切换",
    disconnect: "断开连接",
  },
};
